<template>
  <div class="w-full h-full flex flex-col overflow-auto overflow-x-hidden" style="background-color: var(--bg-sidebar); color: var(--text-sidebar)">
    <div class="flex p-8 pt-4 items-center gap-4 border-b border-white/10">
      <div class="min-w-10 w-10 h-10 overflow-hidden rounded-xl">
        <ImgComponent class="" :src="platform.logo" alt="" />
      </div>
      <div
        class="text-xl whitespace-nowrap duration-300"
        :class="{ 'opacity-0': collapsed }"
      >
        Dashboard
      </div>
    </div>
    <div class="py-2"></div>
    <div class="tourguidEl menuNavs">
      <div
        class="p-4 py-0"
        v-for="(nav, i) in filteredNavs"
        :key="i"
        :permission="nav.permission || 'none'"
      >
        <component
          :is="nav.id ? 'router-link' : 'div'"
          :to="nav.id"
          class="flex p-4 items-center gap-4 ripple rounded-xl transition-all duration-300 border-l-4 border-transparent"
          @click="
            () => {
              nav.event && $bus.emit(nav.event);
              $emit('navClicked');
            }
          "
          :class="[
            nav.id?.includes($route.name) 
              ? 'bg-[var(--bg-nav-active)] border-[var(--color-secondary)]' 
              : 'hover:bg-white/5 border-transparent'
          ]"
        >
          <div class="min-w-7 w-7 h-7">
            <ColorImg
              :src="`/images/navs/${nav.icon}`"
              alt=""
              class="w-full h-full"
              :class="nav.id?.includes($route.name) ? 'bg-[var(--color-secondary)]' : 'bg-gray-400'"
            />
          </div>
          <div
            class="whitespace-nowrap duration-300 font-medium"
            :class="{ 'opacity-0': collapsed, 'text-[var(--color-secondary)]': nav.id?.includes($route.name) }"
          >
            {{ nav.name }}
          </div>
        </component>
      </div>
    </div>
    <div class="py-8"></div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { platform } from '@core/platform';

const emit = defineEmits(['navClicked']);
defineProps({ collapsed: { type: Boolean, default: true } });

const navs = [
  { name: 'Accueil', icon: 'home.svg', id: '/home' },
  { name: 'Transactions', icon: 'history.svg', id: '/history' },
  { name: 'Portefeuille', icon: 'wallet.svg', id: '/wallet', feature: 'hasWallet' },
  { name: 'Clients', icon: 'user.svg', id: '/customers' },
  { name: 'Administrateurs', icon: 'admin.svg', id: '/admins' },
  { name: 'Publicités', icon: 'ads.png', id: '/ads' },
  { name: 'Blacklist', icon: 'lock.svg', id: '/blacklist' },
  { name: 'Finances', icon: 'fees.png', id: '/fees' },
  { name: 'Notifications', icon: 'bell.svg', id: '/notifications' },
  { name: 'Réglages', icon: 'setting.svg', id: '/setting' },
  {
    name: 'Déconnexion',
    icon: 'logout.svg',
    event: 'USER_LOGOUT' // Using literal text as fallback for constants if needed, but constants are usually injected
  }
];

const filteredNavs = computed(() => {
  return navs.filter(nav => !nav.feature || platform[nav.feature]);
});
</script>
